import { ref } from 'vue'

import type { PasswordResetFormOutput } from '@fondof-ui/validation'
import { useUrlSearchParams } from '@vueuse/core'

import {
  type AuthSource,
  triggerResetPasswordEvent,
  triggerResetPasswordFailedEvent,
} from '@fond-of/event'
import { forgotPassword } from '@fond-of/shop-api'

const email = ref()

export const usePasswordReset = (propsEmail?: string) => {
  const {
    email: initialEmail,
    callbackUrl,
    source = 'navigation',
  } = useUrlSearchParams<{
    email?: string
    callbackUrl?: string
    source?: AuthSource
  }>()

  if (propsEmail) {
    email.value = propsEmail
  }

  const onPasswordReset = async (attributes: PasswordResetFormOutput) => {
    try {
      await forgotPassword({ ...attributes, callbackUrl, source })

      triggerResetPasswordEvent({
        email: attributes.email,
        source,
      })

      email.value = attributes.email
    } catch (error) {
      triggerResetPasswordFailedEvent({
        error,
        email: attributes.email,
        source,
      })
    }
  }

  return {
    email,
    initialEmail,
    onPasswordReset,
  }
}
